import type { ReactElement } from 'react'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'

export function DetailsSection({ derived }: { derived: ContactCardFacts }): ReactElement | null {
  const { lead, recall, prose, facts } = derived
  if (lead || recall || !(prose || facts.details.length > 0)) return null
  return (
    <p className="mt-1.5 truncate text-body-xs text-minimal">
      {prose && <span className="text-subtle">{prose}</span>}
      {prose && facts.details.length > 0 && ` · `}
      {facts.details.join(` · `)}
    </p>
  )
}
